import { jsxs as o, jsx as a } from "react/jsx-runtime";
import { FormLabel as l } from "@chakra-ui/react";
import { Icon as i } from "../icon/icon.js";
import { ThemeSpaceVariable as t, ThemeIconSizeVariable as p } from "../../theme/theme-types.js";
function c({ children: m, icon: r, ...e }) {
  return /* @__PURE__ */ o(l, { ...e, children: [
    r && /* @__PURE__ */ a(i, { size: p.Small, icon: r, mr: t.XSmall }),
    m
  ] });
}
export {
  c as FormLabel
};
